module.exports = __webpack_public_path__ + "static/VS_icon04-01-bf6c6579781199e176e85ffc0574dacb.png";